import { handleMessageError } from '@/utils';
import { ExternalToast, toast } from 'sonner';

export const toastSomethingError = (error?: unknown, props?: ExternalToast) =>
  toast.error(handleMessageError(error), {
    ...props,
    description: props?.description || 'There was a problem with your request.',
  });
